const desktopMediaQuery = window.matchMedia('(min-width: 992px)')
const reducedMotionMediaQuery = window.matchMedia('(prefers-reduced-motion: reduce)')
const rotationInterval = 5000

const ServiceBlock = {
  init() {
    document.querySelectorAll<HTMLElement>('[data-service-block]').forEach((block) => {
      const items = Array.from(block.querySelectorAll<HTMLElement>('[data-service-block-item]'))
      const images = Array.from(block.querySelectorAll<HTMLElement>('[data-service-block-image]'))

      if (items.length < 2 || !images.length) return

      let activeIndex = 0
      let intervalId: number | undefined
      // A block still to be revealed waits for its first item to be in place.
      let isRevealed = !items[0].classList.contains('tvg-reveal')

      const setActiveItem = (index: number) => {
        activeIndex = index

        items.forEach((item) => {
          item.classList.toggle('is-active', Number(item.dataset.serviceBlockIndex) === activeIndex)
        })

        images.forEach((image) => {
          image.classList.toggle('is-active', Number(image.dataset.serviceBlockIndex) === activeIndex)
        })
      }

      const stopRotation = () => {
        if (intervalId !== undefined) {
          window.clearInterval(intervalId)
          intervalId = undefined
        }

        block.classList.remove('is-rotating')
      }

      const startRotation = () => {
        stopRotation()

        if (!isRevealed || !desktopMediaQuery.matches || reducedMotionMediaQuery.matches) return

        block.classList.add('is-rotating')
        intervalId = window.setInterval(() => {
          setActiveItem((activeIndex + 1) % items.length)
        }, rotationInterval)
      }

      const updateRotation = () => {
        setActiveItem(0)
        startRotation()
      }

      desktopMediaQuery.addEventListener('change', updateRotation)
      reducedMotionMediaQuery.addEventListener('change', updateRotation)
      items[0].addEventListener('tvg-revealed', () => {
        isRevealed = true
        startRotation()
      }, { once: true })
      startRotation()
    })
  },
}

export default ServiceBlock
